<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<v-toolbar class="elevation-1">
			<v-toolbar-title>{{ title }}</v-toolbar-title>
			<div class="flex-grow-1"></div>
		</v-toolbar>
		<FormCard :title="$t('general.active_projects')">
			<template v-slot:form>
				<div class="active_projects_content">
					<v-chip v-for="project in projects"
					        :color="project.background_color"
					        :text-color="project.text_color"
					        class="ma-2"
							:key="project.id"
					>{{project.name}}
					</v-chip>
				</div>
			</template>
		</FormCard>
		<FormCard v-if="is_admin">
			<template v-slot:form>
				<v-form autocomplete="off">
					<v-row dense>
						<!-- Date pickers -->
						<v-col cols="12" sm="6" md="6" lg="3">
							<!-- Start date input -->
							<v-menu v-model="start_time_picker"
							        :close-on-content-click="false"
							        :nudge-right="40"
							        transition="scale-transition"
							        offset-y
							        min-width="290px"
							>
								<template v-slot:activator="{ on }">
									<v-text-field class="custom_textfield"
									              v-model="computedStartDateFormatted"
									              :label="$t('general.from')"
									              append-icon="event"
									              readonly
									              v-on="on"
									              outlined
									></v-text-field>
								</template>
								<v-date-picker v-model="search_options.start_time"
								               @input="start_time_picker = false"
								></v-date-picker>
							</v-menu>
						</v-col>
						<v-col cols="12" sm="6" md="6" lg="3">
							<!-- End date input-->
							<v-menu v-model="end_time_picker"
							        :close-on-content-click="false"
							        :nudge-right="40"
							        transition="scale-transition"
							        offset-y
							        min-width="290px"
							>
								<template v-slot:activator="{ on }">
									<v-text-field class="custom_textfield"
									              v-model="computedEndDateFormatted"
									              :label="$t('general.to')"
									              append-icon="event"
									              readonly
									              v-on="on"
									              outlined
									></v-text-field>
								</template>
								<v-date-picker v-model="search_options.end_time"
								               @input="end_time_picker = false"
								></v-date-picker>
							</v-menu>
						</v-col>
					</v-row>
				</v-form>
				<v-row>
					<v-col cols="12" md="12" lg="6" xl="6">
						<Chart :chart_options="bar_chart_options"></Chart>
					</v-col>
					<v-col cols="12" md="12" lg="6" xl="6">
						<Chart :chart_options="pie_chart_options"></Chart>
					</v-col>
					<v-col cols="12">
						<Chart :chart_options="bar_chart_options_devs"></Chart>
					</v-col>
				</v-row>
			</template>
		</FormCard>
	</div>
</template>

<script>
    import FormCard from '../components/FormCard.vue'
    import Chart from '../components/Chart.vue'

    export default {
        components: {
            FormCard,
            Chart,
        },
        props: {
            title: {
                type: String,
            }
        },
        computed: {
            computedStartDateFormatted() {
                return this.search_options.start_time ? this.moment(this.search_options.start_time).format('DD/MM/YYYY') : ''
            },
            computedEndDateFormatted() {
                return this.search_options.end_time ? this.moment(this.search_options.end_time).format('DD/MM/YYYY') : ''
            },
        },
        data() {
            return {
                clients: null,
                projects: null,
                is_admin: false,

                start_time_picker: false,
                end_time_picker: false,
                search_options: {
                    start_time: new Date(`${new Date().getUTCFullYear()}-${new Date().getUTCMonth() + 1}`).toISOString().substr(0, 10),
                    end_time: new Date().toISOString().substr(0, 10),
                },
                search_criteria: {},

                bar_chart_options: {
                    tooltip: {
                        show: true,
                        showContent: true,
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    legend: {
                        data: ['Hours', 'Charges']
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'value'
                    },
                    yAxis: {
                        type: 'category',
                        data: []
                    },
                    series: [
                        {
                            name: 'Hours',
                            type: 'bar',
                            stack: 'hours_charges',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'insideLeft'
                                }
                            },
                            data: []
                        },
                        {
                            name: 'Charges',
                            type: 'bar',
                            stack: 'hours_charges',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'insideLeft'
                                }
                            },
                            data: []
                        },
                    ]
                },
                pie_chart_options: {
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b} : {c} ({d}%)"
                    },
                    legend: {
                        orient: 'horizontal',
                        left: 'center',
                        data: []
                    },
                    series: [
                        {
                            name: 'Hours',
                            type: 'pie',
                            radius: '55%',
                            center: ['50%', '50%'],
                            data: [],
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                },
                bar_chart_options_devs: {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    legend: {
                        data: ['Billable', 'Non-billable']
                    },
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            color: '#274e13',
                            name: 'Billable',
                            type: 'bar',
                            stack: 'billable',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'insideTop'
                                }
                            },
                            barWidth: 60,
                            data: [],
                        },
                        {
                            color: '#274e1380',
                            name: 'Non-billable',
                            type: 'bar',
                            stack: 'non-billable',
                            label: {
                                normal: {
                                    show: true,
                                    position: 'insideTop'
                                }
                            },
                            barWidth: 60,
                            data: []
                        },
                    ]
                },
            }
        },
        methods: {
            async getClientsProjects() {
                // Get clients
                this.clients = (await this.$store.dispatch('fetchData', {
                    url: '/api/clients/all',
                    params: {projects_conditions: {'is_active': 1}}
                }))[0];

                // Store projects
                let projects_temp = [];
                this.clients.forEach(client => {
                    if (client.projects.length > 0) {
                        client.projects.forEach(project => projects_temp.push(project))
                    }
                });
                this.projects = projects_temp;
            },
            async getStatsData() {
                // Properly format datetime for database
//                this.search_criteria.start_time = `2016-1-1 00:00:00`;
                this.search_criteria.start_time = `${this.search_options.start_time} 00:00:00`;
                this.search_criteria.end_time = `${this.search_options.end_time} 23:59:59`;

                // Get stats data
                const response = await this.$store.dispatch('fetchData', {
                    url: `/api/work-hours/stats`,
                    params: {'search_options': this.search_criteria}
                });

                // Set projects bar-chart data
                response.projects_stats.forEach((item) => {
                    this.bar_chart_options.yAxis.data.push(item.name);
                    this.bar_chart_options.series[0].data.push(item.work_hours_sum);
                    this.bar_chart_options.series[1].data.push(item.work_hours_charge);
                });

                // Set clients pie-chart data
                response.clients_stats.forEach((item) => {
                    this.pie_chart_options.legend.data.push(item.name);
                    this.pie_chart_options.series[0].data.push({
                        value: item.work_hours_sum,
                        name: item.name,
                        itemStyle: {color: item.color}
                    });
                });

                // Set users bar-chart data
                response.devs_stats.forEach((item) => {
                    this.bar_chart_options_devs.xAxis.data.push(item.name);
                    this.bar_chart_options_devs.series[0].data.push({
                        value: item.billable_whs_sum,
                        name: item.name,
                        itemStyle: {color: item.color}
                    });
                    this.bar_chart_options_devs.series[1].data.push({
                        value: item.non_billable_whs_sum,
                        name: item.name,
                        itemStyle: {color: `${item.color}80`}
                    });
                });
            }
        },
        async mounted() {
            this.getClientsProjects();
            // If user is admin, get charts data
            if (this.is_admin = this.$store.state.user.roles[0] === 'admin') {
                this.getStatsData();
            }
        },
        watch: {
            search_options: {
                deep: true,
                handler() {
                    this.getStatsData();
                }
            }
        }
    };
</script>
